<template lang="html">
  <div class="edit-ad-wrapper-background">
    <Cropper
      v-if="mainP || pic"
      :src="imageForCropp"
      :extension="extension"
      @cropp="croppImage"
      @giveup="giveup"
    />
    <div v-if="productInfo" class="edit-ad-wrapper">
      <h1>{{ $t('edit.title') }}</h1>
      <div v-for="input in getInputs" :key="input.name" class="inputs-wrapper">
        <div v-if="input.type === 'header'" class="header">
          {{ $t('main.' + input.value) }}
        </div>
        <template v-else-if="input.type === 'prices'">
          <div v-if="productInfo.price_edit === 1">
            <div class="info">
              <span class="info-key"
                >{{ $t('profile.purchase.quantity') }} :</span
              >
              <span class="info-value">
                <input
                  v-model="quantity"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  @change="checkQuantity"
                  :disabled="prices.length > 0"
                  type="number"
                  @keydown="keyUpQuantity"
                  max="99999999"
                  :step="1"
                  :min="4"
                />
              </span>
            </div>
            <!-- jedinicna cena -->
            <div class="info">
              <span class="info-key"
                >{{ $t('profile.purchase.startingPrice') }} :</span
              >
              <span class="info-value">
                <currency-input
                  locale="en"
                  :currency="null"
                  :disabled="prices.length > 0"
                  :value="basePrice"
                  :precision="0"
                  @change="basePrice = parseNumber($event)"
                  maxlength="9"
                />
              </span>
            </div>
            <!-- product discounts: -->
            <div
              v-if="prices.length < 5 && parseInt(quantityMin) < quantity"
              class="info"
            >
              <span class="info-key"
                >{{ $t('profile.purchase.adddiscount') }} :
              </span>
              <span class="info-value prices">
                <span style="margin-right: 5px;"
                  >{{ $t('profile.purchase.of') }}:</span
                >
                <span style="margin-right: 5px;">{{ quantityMin }}</span>
                <span style="margin-right: 5px;"
                  >{{ $t('profile.purchase.to') }}:</span
                >
                <input
                  style="width:auto; margin-right: 5px;"
                  type="number"
                  :min="parseInt(quantityMin) + 1"
                  v-model="quantityMax"
                  :max="quantity"
                  @change="
                    fixNumber(
                      $event.target.min,
                      $event.target.max,
                      'quantityMax'
                    )
                  "
                  @keydown="rangefunction($event)"
                />
                <span style="margin-right: 5px;"
                  >{{ $t('profile.purchase.price') }}:</span
                >
                <input
                  style="width:auto; margin-right: 5px;"
                  v-if="prices.length > 0"
                  type="number"
                  :min="1"
                  v-model="price"
                  @change="
                    fixNumber($event.target.min, $event.target.max, 'price')
                  "
                  :max="getMaxPrice"
                  :step="1"
                />
                <span style="margin-right: 5px;" v-else>
                  {{ basePrice }}
                </span>
                <div @click="addDiscount" class="btn">
                  {{ $t('profile.purchase.add') }}
                </div>
              </span>
            </div>

            <div class="info">
              <span class="info-key"
                >{{ $t('profile.purchase.discounts') }} :</span
              >
              <span
                v-for="(price, index) in prices"
                :key="price.id"
                style="flex-grow: 0;"
                class="info-value"
              >
                {{ price.min }} - {{ price.max }} : {{ price.price }}&nbsp;{{
                  currency
                }}{{ prices[index + 1] ? ',' : '' }}&nbsp;&nbsp;
              </span>
              <img
                style="cursor: pointer;"
                v-if="prices.length > 0"
                @click="removeDiscount"
                src="@/assets/icons/trash.png"
                alt="trash icon"
              />
            </div>
            <div class="info back">
              <span class="info-key" style="width: 100%;"
                >*{{ $t('main.editPrices') }}</span
              >
            </div>
            <div class="info back">
              <span class="info-key" style="width: 100%;"
                >*{{ $t('profile.purchase.minDiscount') }}</span
              >
            </div>
          </div>
        </template>
        <div v-else-if="input.type === 'socials'">
          <div v-for="social in socials" :key="social.sct_id" class="info">
            <span class="info-key">{{ social.sct_name }} :</span>
            <span class="info-value">
              <input maxlength="1100" type="text" v-model="social.link" />
            </span>
          </div>
        </div>
        <div
          v-else-if="
            input.type === 'filters' &&
              productInfoEdited.cat_id &&
              Object.keys(filters).length !== 0 &&
              filters.constructor === Object
          "
          class="info"
        >
          <span class="info-key">{{ $t('profile.purchase.filters') }} :</span>
          <span class="info-value">
            <div
              v-for="(value, name) in filters"
              :key="name"
              class="filter-wrapper"
            >
              <dropdown
                :defaultText="name"
                :selected="getFilterValue(name)"
                :list="value"
                @changeOption="
                  changeFilter(name, $event), (filtersChanged = true)
                "
              />
            </div>
          </span>
        </div>
        <div v-else-if="input.type === 'declaration'" class="info">
          <span class="info-key"
            >{{ $t('profile.purchase.pro_declaration') }}* :</span
          >
          <div
            class="info-value"
            style="flex-direction: column; align-items: flex-start;"
          >
            <div style="flex-direction: row; display: flex;">
              <div
                class="declaration-wrapper"
                v-for="(declaration,
                index) in productInfoEdited.pro_declaration"
                :key="index"
              >
                {{ declaration.name ? declaration.name : declaration.prq_name }}
                <img
                  style="cursor: pointer;"
                  v-if="productInfoEdited.pro_declaration.length > 0"
                  @click="productInfoEdited.pro_declaration.splice([index], 1)"
                  src="@/assets/icons/trash.png"
                  alt="trash icon"
                />
              </div>
              <label
                v-if="productInfoEdited.pro_declaration.length < 5"
                for="pro_declaration"
                class="btn"
                >{{ $t('profile.purchase.choose') }}</label
              >
              <input
                v-if="productInfoEdited.pro_declaration.length < 5"
                style="display: none;"
                ref="pro_declaration"
                accept=".txt, .docx, .doc, .odt"
                id="pro_declaration"
                type="file"
                @change="
                  productInfoEdited.pro_declaration.push($event.target.files[0])
                "
              />
            </div>
            <span style="margin-top: 0px;">{{ $t('main.orWrite') }}</span>
            <input
              maxlength="1100"
              style="margin-top: 0px;"
              type="text"
              v-model="productInfoEdited.pro_declaration_text"
            />
          </div>
        </div>
        <div v-else class="info">
          <span class="info-key"
            >{{ $t('profile.purchase.' + input.name) }} :</span
          >
          <span v-if="input.type === 'text'" class="info-value">
            <input
              :maxlength="input.length"
              v-model="productInfoEdited[input.name]"
              type="text"
            />
          </span>
          <span v-else-if="input.type === 'date'" class="info-value">
            <!-- <input type="datetime-local" v-model="date"/> -->
            <datetime v-model="date" :min-datetime="nowDate" type="datetime" />
          </span>
          <span v-else-if="input.type === 'textarea'" class="info-value">
            <textarea
              maxlength="1100"
              type="text"
              v-model="productInfoEdited[input.name]"
              rows="5"
            />
          </span>
          <span v-else-if="input.type === 'checkbox'" class="info-value">
            <input
              @change="changeCheked(input.name, $event)"
              :checked="productInfoEdited[input.name]"
              type="checkbox"
            />
          </span>
          <span v-else-if="input.type === 'switch'" class="info-value">
            <input
              type="checkbox"
              @change="
                changeCheked('pro_individuals_trading', $event),
                  (otherRights2Condition = $event.target.checked)
              "
              :checked="productInfoEdited['pro_individuals_trading']"
            />
          </span>
          <span v-else-if="input.type === 'dropdown'" class="info-value">
            <dropdown
              v-if="input.removable"
              :defaultText="$t('profile.purchase.choose')"
              :selected="input.value"
              :list="input.dropdownList"
              :removable="true"
              @remove="
                ;(input.value = null), (productInfoEdited[input.name] = 0)
              "
              @changeOption="
                ;(input.value = $event),
                  (productInfoEdited[input.name] = $event.value)
              "
            />
            <dropdown
              v-else-if="
                input.name !== 'cat_id' && input.name !== 'cat_id_parent'
              "
              :defaultText="$t('profile.purchase.choose')"
              :selected="input.value"
              :list="input.dropdownList"
              @changeOption="
                ;(input.value = $event),
                  (productInfoEdited[input.name] = $event.value)
              "
            />
            <dropdown
              v-else-if="input.name === 'cat_id_parent'"
              :defaultText="$t('profile.purchase.choose')"
              :selected="input.value"
              :list="input.dropdownList"
              @changeOption="selectCategories($event), (input.value = $event)"
            />

            <dropdown
              v-else-if="input.name === 'cat_id' && subCategoryControll"
              :defaultText="$t('profile.purchase.subcategory')"
              :selected="input.value"
              :list="input.dropdownList"
              @changeOption="
                ;(input.value = $event),
                  (productInfoEdited[input.name] = $event.value)
              "
            />
          </span>
          <span v-else-if="input.type === 'select'" class="info-value">
            <v-select
              :placeholder="$t('profile.purchase.region')"
              v-model="input.value"
              multiple
              :options="input.dropdownList"
            >
              <template #open-indicator="{ attributes }">
                <!-- <span v-bind="attributes">🔽</span> -->
                <img
                  v-bind="attributes"
                  src="@/assets/icons/dropdownArrowBig.png"
                  alt="dropdown arrow icon"
                />
              </template>
              <template #no-options="{ search, searching, loading }">
                <span></span>
              </template>
            </v-select>
          </span>
          <span v-if="input.type === 'mainImage'" class="info-value">
            <img
              v-if="productInfoEdited.img_id !== null"
              :src="getMainImage"
              alt="glavna slika"
            />
            <img
              v-if="mainImage !== null"
              :src="mainImageUrl[0].src"
              alt="glavna slika"
            />
            <div
              v-if="productInfoEdited.img_id !== null"
              @click="productInfoEdited.img_id = null"
              class="btn"
            >
              {{ $t('item.remove') }}
            </div>
            <label
              v-if="productInfoEdited.img_id === null && mainImage === null"
              for="main_image"
              class="btn"
              >{{ $t('profile.purchase.choose') }}</label
            >
            <input
              style="display: none;"
              ref="main_image"
              id="main_image"
              accept=".png, .jpg, .jpeg"
              type="file"
              @change="setMainImage($event.target.files)"
            />
            <div
              v-if="mainImage !== null"
              @click=";(mainImage = null), (mainImageUrl = null)"
              class="btn"
            >
              {{ $t('item.remove') }}
            </div>
            <!-- <div v-if="mainImage !== null || productInfoEdited.img_id === null" @click="mainImage = null, mainImageUrl = null, productInfoEdited.img_id = JSON.parse(JSON.stringify(productInfo.img_id))" class="btn">odustani</div> -->
          </span>
          <span v-if="input.type === 'images'" class="info-value">
            <div
              v-for="(img, index) in productInfoEdited[input.name]"
              :key="img"
              class="img-wrapper"
            >
              <img
                v-if="isMainImage(img)"
                :src="getImage(img)"
                @click="removeImage(img, index)"
                alt="product image"
              />
              <div
                v-if="isMainImage(img)"
                @click="removeImage(img, index)"
                class="remove"
              >
                {{ $t('item.remove') }}
              </div>
            </div>
            <div
              v-for="(img, index) in newImagesPreview"
              :key="index"
              class="img-wrapper"
            >
              <img
                :src="img.src"
                @click="removeNewImage(index)"
                alt="product image"
              />
              <div @click="removeNewImage(index)" class="remove">
                {{ $t('item.remove') }}
              </div>
            </div>
            <label v-if="numImages < 14" for="image" class="btn">{{
              $t('profile.purchase.choose')
            }}</label>
            <input
              style="display: none;"
              ref="images"
              id="image"
              accept=".png, .jpg, .jpeg"
              type="file"
              @change="setImages($event.target.files)"
            />
          </span>
          <span v-if="input.type === 'pro_quality'" class="info-value">
            <div
              v-for="(img, index) in productInfoEdited[input.name]"
              :key="img.link"
              class="img-wrapper"
            >
              <img
                :src="getImage(img.link)"
                @click="removeProQuality(img, index)"
                alt="product image"
              />
              <div @click="removeProQuality(img, index)" class="remove">
                {{ $t('item.remove') }}
              </div>
            </div>
            <div
              v-for="(img, index) in newProQualityPreview"
              :key="index"
              class="img-wrapper"
            >
              <img
                :src="img.src"
                @click="
                  newProQuality.splice(index, 1),
                    (newProQualityPreview = createPreviews(newProQuality))
                "
                alt="product image"
              />
              <div
                @click="
                  newProQuality.splice(index, 1),
                    (newProQualityPreview = createPreviews(newProQuality))
                "
                class="remove"
              >
                {{ $t('item.remove') }}
              </div>
            </div>
            <label v-if="numProofQuality < 5" for="pro_quality" class="btn">{{
              $t('profile.purchase.choose')
            }}</label>
            <input
              style="display: none;"
              ref="pro_quality"
              id="pro_quality"
              accept=".png, .jpg, .jpeg"
              type="file"
              @change="setProQuality($event.target.files)"
            />
          </span>
        </div>
      </div>
      <div class="info">
        <div @click="saveChanges" class="btn">
          {{ $t('button.button_save') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/components/dropdown.vue'
import { api, baseURL } from '@/api'
import Cropper from '@/components/newAd/cropper.vue'
import helper from '@/js/helper.js'
export default {
  name: 'editAd',
  components: {
    Dropdown,
    Cropper
  },
  data () {
    return {
      quantity: null,
      quantityMin: 1,
      quantityMax: null,
      prices: [],
      basePrice: 0,
      currency: null,
      price: null,
      otherRights2Condition: false,
      otherRights2ConditionFill: false,
      productInfo: null,
      productInfoEdited: null,
      mainImage: null,
      mainImageUrl: null,
      newImages: [],
      newImagesPreview: [],
      deletedImages: [],
      newProQuality: [],
      newProQualityPreview: [],
      deletedProQuality: [],
      date: null,
      nowDate: new Date().toISOString().slice(0, 10),
      socials: [],
      subCategoryControll: false,
      numProofQuality: 0,
      numImages: 0,
      declarations: [],
      inputs: [
        {
          type: 'header',
          value: 'mainSection'
        },
        {
          name: 'pro_name',
          type: 'text',
          length: 40
        },
        {
          name: 'pro_expiry',
          type: 'date'
        },
        {
          type: 'prices'
        },
        {
          name: 'mun_id',
          type: 'dropdown',
          value: null,
          dropdownList: []
        },
        // {
        //   name: 'cur_id',
        //   type: 'dropdown',
        //   value: null,
        //   dropdownList: []
        // },
        {
          name: 'cat_id_parent',
          type: 'dropdown',
          value: null,
          dropdownList: []
        },
        {
          name: 'cat_id',
          type: 'dropdown',
          value: null,
          dropdownList: []
        },
        {
          name: 'filters',
          type: 'filters'
        },
        {
          name: 'region',
          type: 'select',
          value: null,
          dropdownList: []
        },
        {
          name: 'pro_info',
          type: 'textarea'
        },
        {
          name: 'pro_description',
          type: 'textarea'
        },
        {
          name: 'pro_made_in',
          type: 'text',
          length: 1100
        },
        {
          name: 'pro_declaration',
          type: 'declaration'
        },
        {
          name: 'pro_selling_price',
          type: 'text',
          length: 1100
        },
        {
          type: 'header',
          value: 'socialsSection'
        },
        {
          name: 'socials',
          type: 'socials'
        },
        {
          type: 'header',
          value: 'imagesSection'
        },
        {
          name: 'img_id',
          type: 'mainImage'
        },
        {
          name: 'pro_image',
          type: 'images'
        },
        {
          name: 'pro_quality',
          type: 'pro_quality'
        },
        {
          type: 'header',
          value: 'localSection'
        },
        {
          name: 'pro_shipping_info',
          type: 'text',
          length: 1100
        },
        {
          name: 'pro_shipping_time',
          type: 'text',
          length: 1100
        },
        {
          name: 'pro_seller_shipping',
          type: 'checkbox'
        },
        {
          name: 'pro_free_shipping',
          type: 'checkbox'
        },
        {
          name: 'pro_shipping_included',
          type: 'checkbox'
        },
        {
          name: 'pro_shipping_additional',
          type: 'text',
          length: 1100
        },
        {
          type: 'header',
          value: 'international'
        },
        {
          name: 'pro_international_shipping',
          type: 'text',
          length: 1100
        },
        {
          type: 'header',
          value: 'transportSection'
        },
        {
          name: 'trc_id',
          type: 'dropdown',
          value: null,
          dropdownList: [],
          removable: true
        },
        {
          name: 'trc_id_naval',
          type: 'dropdown',
          value: null,
          dropdownList: [],
          removable: true
        },
        {
          type: 'header',
          value: 'quitSection'
        },
        {
          name: 'pro_limitations',
          type: 'text',
          length: 1100
        },
        {
          name: 'pro_reject',
          type: 'checkbox'
        },
        {
          name: 'pro_abandon',
          type: 'checkbox'
        },
        {
          name: 'pro_abandon_no_offers',
          type: 'checkbox'
        },
        {
          type: 'header',
          value: 'responsibilitySection'
        },
        {
          name: 'pro_jurisdiction',
          type: 'text',
          length: 1100
        },
        {
          name: 'rst_id',
          type: 'dropdown',
          value: null,
          dropdownList: [],
          removable: true
        },
        {
          type: 'header',
          value: 'otherRights'
        },
        {
          name: 'pro_payment_info',
          type: 'text',
          length: 1100
        },
        {
          name: 'pro_deposit_info',
          type: 'text',
          length: 1100
        },
        {
          name: 'pro_contract_requirements',
          type: 'text',
          length: 1100
        },
        {
          name: 'pro_claims_responsibility',
          type: 'text',
          length: 1100
        },
        {
          name: 'pro_claims_info',
          type: 'text',
          length: 1100
        },
        {
          name: 'pro_warranty_info',
          type: 'text',
          length: 1100
        },
        {
          name: 'pro_warranty_address',
          type: 'text',
          length: 1100
        },
        {
          name: 'otherRights2Condition',
          type: 'switch'
        },
        {
          type: 'header',
          value: 'otherRights2',
          condition: 'otherRights2Condition'
        },
        {
          name: 'pro_return_shipping_requirements',
          type: 'text',
          length: 1100,
          condition: 'otherRights2Condition'
        },
        {
          name: 'pro_no_reject_condition',
          type: 'text',
          length: 1100,
          condition: 'otherRights2Condition'
        },
        {
          name: 'pro_postal_info',
          type: 'text',
          length: 1100,
          condition: 'otherRights2Condition'
        },
        {
          name: 'pro_return_shipping_cost',
          type: 'text',
          length: 1100,
          condition: 'otherRights2Condition'
        },
        {
          name: 'pro_court_avoidance',
          type: 'text',
          length: 1100,
          condition: 'otherRights2Condition'
        },
        {
          name: 'pro_rules',
          type: 'text',
          length: 1100,
          condition: 'otherRights2Condition'
        },
        {
          name: 'pro_reject_rules',
          type: 'text',
          length: 1100,
          condition: 'otherRights2Condition'
        }
      ],
      mainP: false,
      pic: false,
      imageForCropp: null,
      temporarilyPicName: '',
      filters: {},
      selectedFilters: {},
      filtersChanged: false,
      extension: ''
    }
  },
  mounted () {
    // this.setUpData()
    // },
    // activated () {

    this.setUpData()
  },
  methods: {
    async setUpData () {
      await this.getTransportDropdowns()
      await this.getTransportNavalDropdowns()
      await this.getRestrictions()
      await this.getCategories()
      await this.getRegions()
      await this.getMeasurementUnits()
      await this.getCurrencies()
      await this.getSocialTypes()
      this.getDetails()
    },
    checkQuantity () {
      console.log('asd', this.quantity)
      if (parseInt(this.quantity) < 4) {
        this.quantity = 4
      }
    },
    keyUpQuantity (e) {
      if (this.quantity >= 99999999) {
        e.preventDefault()
      }
    },
    fixNumber (min, max, value) {
      console.log(
        this.parseNumber(this[value]),
        this.parseNumber(max),
        this.parseNumber(min)
      )
      if (this.parseNumber(this[value]) > this.parseNumber(max)) {
        this[value] = this.parseNumber(max)
      } else if (this.parseNumber(this[value]) < this.parseNumber(min)) {
        this[value] = this.parseNumber(min)
      }
    },
    parseNumber (num) {
      return parseFloat(((num * 100) / 100).toFixed(2))
    },
    removeDiscount () {
      this.prices.pop()
      if (this.prices[this.prices.length - 1]) {
        this.quantityMin = parseInt(this.prices[this.prices.length - 1].max) + 1
        this.quantityMax = parseInt(this.prices[this.prices.length - 1].max) + 2
      } else {
        this.quantityMin = 1
        this.quantityMax = 2
      }
    },
    addDiscount () {
      if (this.prices.length === 0) {
        this.price = this.basePrice
      }
      let quantityMin = parseInt(this.quantityMin)
      let quantityMax = parseInt(this.quantityMax)
      let price = this.parseNumber(this.price)
      if (!quantityMin || quantityMin < 1) {
        console.log('quantityMin los')
        return
      }
      if (!quantityMax || quantityMax <= quantityMin) {
        console.log('quantityMax los')
        return
      }
      if (quantityMax > this.quantity) {
        this.$toast.error(this.$t('main.quantityMaxError'), {
          duration: 8000
        })
        return
      }
      if (!price) {
        console.log('price los')
        return
      }
      let obj = {
        min: quantityMin,
        max: quantityMax,
        price: price
      }
      this.prices.push(obj)
      this.quantityMin = parseInt(this.quantityMax) + 1
      this.quantityMax = parseInt(this.quantityMax) + 2
      this.price = null
    },
    async getSocialTypes () {
      api.getSocialTypes().then(res => {
        this.socials = res.data.data
      })
    },
    isMainImage (str) {
      if (!this.productInfoEdited.img_id) {
        return true
      }
      if (
        this.productInfoEdited.img_id === parseInt(str.replace(/^\D+/g, ''))
      ) {
        return false
      }
      return true
    },
    croppImage (e) {
      if (this.mainP) {
        this.mainImageUrl = []
        this.mainImage = []
        this.mainImage.push(helper.base64toFile(e, this.temporarilyPicName))
        this.mainImageUrl.push({ name: this.temporarilyPicName, src: e })
      }
      if (this.pic) {
        this.newImages.push(helper.base64toFile(e, this.temporarilyPicName))
        this.newImagesPreview.push({ name: this.temporarilyPicName, src: e })

        console.log(e)
        console.log(helper.base64toFile(e, this.temporarilyPicName))
      }
      this.mainP = false
      this.pic = false
      this.imageForCropp = null
      this.$refs.main_image.value = null
      this.$refs.images.value = null
      this.temporarilyPicName = ''
    },
    giveup () {
      this.mainP = false
      this.pic = false
      this.imageForCropp = null
      this.$refs.main_image.value = null
      this.$refs.images.value = null
      this.temporarilyPicName = ''
    },
    setMainImage (files) {
      if (files.length > 0) {
        if (files[0].size > 409600) {
          this.$toast.error(this.$t('details.details.imageSizeError'), {
            duration: 8000
          })
          this.$refs.main_image.value = null
          return
        }
        // this.mainImage = files
        // this.mainImageUrl = this.createPreviews(this.mainImage)
        let reader = new FileReader()
        reader.onload = e => {
          // this.imgs.push(e.target.result)
          this.imageForCropp = e.target.result
          this.temporarilyPicName = Math.random() + files[0].name
          this.extension = files[0].type
          // console.log('name---' + files[0].name)
          if (this.imageForCropp !== null) {
            this.mainP = true
          }
        }
        reader.readAsDataURL(files[0])
      }
    },
    setImages (files) {
      if (files.length > 0) {
        if (files[0].size > 409600) {
          this.$toast.error(this.$t('details.details.imageSizeError'), {
            duration: 8000
          })
          this.$refs.images.value = null
          return
        }
        // this.newImages.push(files[0])
        // this.newImagesPreview = this.createPreviews(this.newImages)
        let reader = new FileReader()
        reader.onload = e => {
          // this.imgs.push(e.target.result)
          this.imageForCropp = e.target.result
          this.temporarilyPicName = Math.random() + files[0].name
          this.extension = files[0].type
          // console.log('name---' + files[0].name)
          if (this.imageForCropp !== null) {
            this.pic = true
          }
        }
        reader.readAsDataURL(files[0])
      }
    },
    setProQuality (files) {
      if (files.length > 0) {
        if (files[0].size > 1024 * 2000) {
          this.$toast.error(this.$t('details.details.imagesSizeQuality'), {
            duration: 8000
          })
          this.$refs.pro_quality.value = null
          return
        }
        this.newProQuality.push(files[0])
        this.newProQualityPreview = this.createPreviews(this.newProQuality)
      }
    },
    saveChanges () {
      if (!this.quantity) {
        this.$toast.error(this.$t('renew.quantityMissing'), {
          duration: 8000
        })
        return
      }
      if (this.prices.length < 2 || this.prices.length > 5) {
        this.$toast.error(this.$t('renew.pricesLengthError'), {
          duration: 8000
        })
        return
      }
      if (
        parseInt(this.prices[this.prices.length - 1].max) !==
        parseInt(this.quantity)
      ) {
        this.$toast.error(this.$t('renew.useAllQuantityError'), {
          duration: 8000
        })
        return
      }
      let arrRes = []
      for (var i = 0; i < this.inputs.length; i++) {
        if (this.inputs[i].name === 'region' && this.inputs[i].value) {
          console.log(this.inputs[i])
          for (var j = 0; j < this.inputs[i].value.length; j++) {
            arrRes.push(this.inputs[i].value[j].value)
          }
        }
      }
      if (arrRes.length === 0) {
        this.productInfoEdited.regions = false
      } else {
        this.productInfoEdited.regions = arrRes
      }
      this.productInfo.pro_expiry = this.productInfo.pro_expiry.substring(0, 16)
      this.date = this.date.substring(0, 16)
      let dif = {}
      for (var variable in this.productInfo) {
        if (this.productInfo.hasOwnProperty(variable)) {
          if (this.productInfo[variable] !== this.productInfoEdited[variable]) {
            dif[variable] = this.productInfoEdited[variable]
          }
        }
      }
      if (this.date === this.productInfo.pro_expiry.replace(' ', 'T')) {
        delete dif.pro_expiry
      }
      dif.socials = JSON.stringify(this.socials)
      if (!this.filtersChanged) {
        delete dif.filters
      }
      var formData = new FormData()
      for (var key in dif) {
        if (key === 'img_id') {
          formData.append('main_image_delete', true)
        } else {
          formData.append(key, dif[key])
        }
      }
      if (this.mainImage) {
        formData.append('main_image', this.mainImage[0])
      }
      if (this.deletedImages.length > 0) {
        for (var i = 0; i < this.deletedImages.length; i++) {
          formData.append('deleted_images', this.deletedImages[i])
        }
      }
      if (this.newImages.length > 0) {
        for (i = 0; i < this.newImages.length; i++) {
          formData.append('images', this.newImages[i])
        }
      }
      if (this.deletedProQuality.length > 0) {
        for (i = 0; i < this.deletedProQuality.length; i++) {
          formData.append('pro_quality_deleted', this.deletedProQuality[i])
        }
      }
      if (this.newProQuality.length > 0) {
        for (i = 0; i < this.newProQuality.length; i++) {
          formData.append('pro_quality', this.newProQuality[i])
        }
      }
      formData.append('prices', JSON.stringify(this.prices))
      formData.id = this.$route.params.id
      // declaration setup:
      let newDeclarations = []
      let oldDeclarations = []
      for (i = 0; i < this.productInfoEdited.pro_declaration.length; i++) {
        if (this.productInfoEdited.pro_declaration[i] instanceof File) {
          newDeclarations.push(this.productInfoEdited.pro_declaration[i])
        } else {
          oldDeclarations.push(this.productInfoEdited.pro_declaration[i])
        }
        // formData.append(
        //   'pro_declaration',
        //   this.productInfoEdited.pro_declaration[i]
        // )
      }
      for (i = 0; i < newDeclarations.length; i++) {
        formData.append('pro_declaration', newDeclarations[i])
      }
      console.log(this.declarations, oldDeclarations)
      let deletedDeclarations = this.declarations.filter(
        e => !oldDeclarations.find(a => e.prq_id === a.prq_id)
      )
      // formData.append(
      //   'pro_declaration_deleted',
      //   deletedDeclarations.map(a => a.prq_id)
      // )
      for (i = 0; i < deletedDeclarations.length; i++) {
        formData.append(
          'pro_declaration_deleted',
          deletedDeclarations[i].prq_id
        )
      }
      // END declaration setup:
      api
        .editProduct(formData)
        .then(res => {
          this.$toast.success(this.$t('main.successfulEdit'), {
            duration: 8000
          })
          let params = Object.assign({}, this.$route.params)
          this.$router.push({ name: 'Profile', params: params })
        })
        .catch(e => {
          console.log(e)
          if (e.response.data.status === 'restricted_words') {
            let words = ''
            for (var i = 0; i < e.response.data.name_words.length; i++) {
              words += e.response.data.name_words[i]
              if (e.response.data.name_words[i + 1]) {
                words += ', '
              }
            }
            this.$toast.error(
              this.$t('main.errorCreationRestrictedWords') + words,
              {
                duration: 8000
              }
            )
          } else if (e.response.data.status === 'timeout') {
            this.$toast.error(this.$t('main.timeoutError'), {
              duration: 8000
            })
          } else {
            this.$toast.error(this.$t('main.errorEdit'), {
              duration: 8000
            })
          }
        })
    },
    changeCheked (checkbox, e) {
      console.log(checkbox, e)
      this.productInfoEdited[checkbox] = e.target.checked
    },
    removeNewImage (index) {
      this.newImages.splice(index, 1)
      this.newImagesPreview.splice(index, 1)
    },
    removeImage (img, index) {
      let id = parseInt(img.split('/image/')[1])
      console.log(id, 'id')
      this.deletedImages.push(id)
      this.productInfoEdited.pro_image.splice(index, 1)
    },
    removeProQuality (img, index) {
      let id = parseInt(img.link.split('/quality/')[1])
      console.log(id)
      this.deletedProQuality.push(id)
      this.productInfoEdited.pro_quality.splice(index, 1)
    },
    createPreviews (images) {
      let res = []
      console.log('images.length ' + images.length)
      for (var i = 0; i < images.length; i++) {
        console.log(images[i])
        let obj = {
          name: images[i].name
        }
        var oFReader = new FileReader()
        oFReader.readAsDataURL(images[i])

        oFReader.onload = function (oFREvent) {
          obj.src = oFREvent.target.result
          res.push(obj)
        }
      }
      return res
    },
    setDropdownsValues () {
      for (var i = 0; i < this.inputs.length; i++) {
        if (this.inputs[i].type === 'dropdown') {
          if (this.productInfoEdited[this.inputs[i].name]) {
            for (var j = 0; j < this.inputs[i].dropdownList.length; j++) {
              if (
                this.inputs[i].dropdownList[j].value ===
                this.productInfoEdited[this.inputs[i].name]
              ) {
                this.inputs[i].value = this.inputs[i].dropdownList[j]
              }
            }
          }
        }
        if (this.inputs[i].type === 'select') {
          if (this.productInfoEdited.regions) {
            let arrRes = []
            for (var j = 0; j < this.productInfoEdited.regions.length; j++) {
              let obj = {
                label: this.productInfoEdited.regions[j].reg_name,
                value: this.productInfoEdited.regions[j].reg_id
              }
              arrRes.push(obj)
            }
            this.inputs[i].value = arrRes
          }
        }
      }
    },
    handleFilters (id) {
      this.filters = {}
      let params = {
        id: id
      }
      api.getFilters(params).then(res => {
        let arr = res.data.res
        for (var i = 0; i < arr.length; i++) {
          this.createFilter(arr[i])
        }
      })
    },
    createFilter (data) {
      if (data.options && data.options.length > 0) {
        let arr = []
        for (var i = 0; i < data.options.length; i++) {
          let obj = {
            label: data.options[i].cvl_value,
            value: data.options[i].cvl_id,
            cha_id: data.cha_id,
            cha_datatype: data.cha_datatype
          }
          arr.push(obj)
          for (var j = 0; j < this.productInfo.filters.length; j++) {
            if (
              obj.cha_id === this.productInfo.filters[j].cha_id &&
              String(obj.value) === String(this.productInfo.filters[j].cvl_id)
            ) {
              this.changeFilter(data.cha_type, obj)
            }
          }
        }
        let copy = Object.assign({}, this.filters)
        copy[data.cha_type] = arr
        this.filters = copy
      }
    },
    changeFilter (name, option) {
      let copy = Object.assign({}, this.selectedFilters)
      copy[name] = option
      this.selectedFilters = copy
      let res = []
      for (var variable in this.selectedFilters) {
        if (this.selectedFilters.hasOwnProperty(variable)) {
          let obj = {
            cha_id: this.selectedFilters[variable].cha_id,
            cha_datatype: this.selectedFilters[variable].cha_datatype,
            cvl_id: this.selectedFilters[variable].value
          }
          res.push(obj)
        }
      }
      this.productInfoEdited.filters = JSON.stringify(res)
    },
    getDetails () {
      const params = {
        id: this.$route.params.id
      }
      api
        .getProductInfo(params)
        .then(res => {
          // remove main image from images
          for (var i = 0; i < res.data.data.pro_image.length; i++) {
            if (
              parseInt(res.data.data.pro_image[i].split('/image/')[1]) ===
              res.data.data.img_id
            ) {
              res.data.data.pro_image.splice(i, 1)
            }
          }
          // end remove main image from images
          this.productInfo = res.data.data
          if (
            res.data.data.pro_declaration &&
            res.data.data.pro_declaration.length > 0
          ) {
            this.declarations = JSON.parse(
              JSON.stringify(res.data.data.pro_declaration)
            )
          }
          console.log(this.productInfo.cat_id_parent)
          if (this.productInfo.my_product === 0) {
            this.$router.push('/')
          }
          if (this.productInfo.cat_id_parent) {
            this.getChildCategories(this.productInfo.cat_id_parent)
          }
          if (this.productInfo.cat_id) {
            this.handleFilters(this.productInfo.cat_id)
          }
          this.productInfoEdited = Object.assign({}, this.productInfo)
          this.checkOtherRules(this.productInfo)
          this.currency = res.data.data.cur_id
          this.name = res.data.data.pro_name
          this.quantity = res.data.data.quantity
          this.basePrice = res.data.data.pro_base_price
          this.prices = res.data.data.prices
          this.quantityMin =
            res.data.data.prices[res.data.data.prices.length - 1].max + 1
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.productInfo.pro_expiry = this.$moment
            .utc(this.productInfo.pro_expiry)
            .local()
            .format('YYYY-MM-DDTHH:mm')
          this.date = this.productInfo.pro_expiry.replace(' ', 'T')
          this.fixSocials()
          setTimeout(() => {
            this.setDropdownsValues()
          }, 200)
        })
    },
    fixSocials () {
      for (var i = 0; i < this.socials.length; i++) {
        this.socials[i].link = ''
        if (this.productInfoEdited.socials) {
          for (var j = 0; j < this.productInfoEdited.socials.length; j++) {
            if (
              parseInt(this.socials[i].sct_id) ===
              parseInt(this.productInfoEdited.socials[j].sct_id)
            ) {
              this.socials[i].link = this.productInfoEdited.socials[j].link
            }
          }
        }
      }
    },
    getRestrictions () {
      api
        .getRestrictions()
        .then(res => {
          for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].name === 'rst_id') {
              this.inputs[i].dropdownList = this.fixDropdownData(
                res.data.data,
                'restrictions'
              )
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getTransportDropdowns () {
      let params = { type: 1 }
      api
        .getTransportDropdowns(params)
        .then(res => {
          for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].name === 'trc_id') {
              this.inputs[i].dropdownList = this.fixDropdownData(
                res.data.data,
                'transport'
              )
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getTransportNavalDropdowns () {
      let params = { type: 2 }
      api
        .getTransportDropdowns(params)
        .then(res => {
          for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].name === 'trc_id_naval') {
              this.inputs[i].dropdownList = this.fixDropdownData(
                res.data.data,
                'transport'
              )
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getCurrencies () {
      api
        .getCurrencies()
        .then(res => {
          for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].name === 'cur_id') {
              this.inputs[i].dropdownList = this.fixDropdownData(
                res.data.data,
                'currency'
              )
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getMeasurementUnits () {
      api
        .getMeasurementUnits()
        .then(res => {
          for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].name === 'mun_id') {
              this.inputs[i].dropdownList = this.fixDropdownData(
                res.data.data,
                'measurementUnit'
              )
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getCategories () {
      api
        .getParentCategories()
        .then(res => {
          // console.log(JSON.stringify(res.data.data))
          for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].name === 'cat_id_parent') {
              this.inputs[i].dropdownList = this.fixDropdownData(
                res.data.data,
                'categories'
              )
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getChildCategories (param) {
      this.subCategoryControll = false
      api
        .getChildCategories(param)
        .then(res => {
          for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].name === 'cat_id') {
              this.inputs[i].value = null
              this.inputs[i].dropdownList = this.fixDropdownData(
                res.data.data,
                'subcategories'
              )
            }
          }
          this.subCategoryControll = true
        })
        .catch(e => {
          console.log(e)
        })
    },
    selectCategories (param) {
      console.log('selectCategories' + param.value)
      this.productInfoEdited['cat_id'] = param.value
      this.getChildCategories(param.value)
    },
    selectChildCategories (param) {
      this.subcategory.value = param
    },
    getRegions () {
      let params = {
        type: 'create'
      }
      api
        .getRegions(params)
        .then(res => {
          for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].name === 'region') {
              this.inputs[i].dropdownList = this.fixDropdownData(
                res.data.data,
                'region'
              )
            }
          }
        })
        .then(r => {
          this.fixRegions()
        })
        .catch(e => {
          console.log(e)
        })
    },
    fixRegions () {
      let region = null
      for (var i = 0; i < this.inputs.length; i++) {
        if (this.inputs[i].name === 'region') {
          region = JSON.parse(JSON.stringify(this.inputs[i]))
        }
      }
      if (region.value && region.value.length > 0) {
        for (var i = 0; i < region.value.length; i++) {
          for (var j = 0; j < region.dropdownList.length; j++) {
            if (region.value[i].value === region.dropdownList[j].value) {
              region.value[i] = region.dropdownList[j]
            }
          }
        }
        for (var i = 0; i < this.inputs.length; i++) {
          if (this.inputs[i].name === 'region') {
            this.inputs[i].value = region.value
          }
        }
      }
    },
    fixDropdownData (data, type) {
      let labelIndex
      let valueIndex
      switch (type) {
        case 'transport':
          labelIndex = 'trc_code'
          valueIndex = 'trc_id'
          break

        case 'restrictions':
          labelIndex = 'rst_name'
          valueIndex = 'rst_id'
          break

        case 'currency':
          labelIndex = 'cur_name'
          valueIndex = 'cur_id'
          break

        case 'measurementUnit':
          labelIndex = 'mun_unit'
          valueIndex = 'mun_id'
          break

        case 'categories':
          labelIndex = 'cat_name'
          valueIndex = 'cat_id'
          break

        case 'subcategories':
          labelIndex = 'cat_name'
          valueIndex = 'cat_id'
          break

        case 'region':
          labelIndex = 'reg_name'
          valueIndex = 'reg_id'
          break

        default:
          break
      }

      let res = []
      for (var i = 0; i < data.length; i++) {
        const obj = {
          label: data[i][labelIndex],
          value: data[i][valueIndex]
        }
        res.push(obj)
      }
      return res
    },
    // fixDropdownDatOld (data, type) {
    //   let res = []
    //   if (type === 'transport') {
    //     for (var i = 0; i < data.length; i++) {
    //       let obj = {
    //         label: data[i].trc_code,
    //         value: data[i].trc_id
    //       }
    //       res.push(obj)
    //     }
    //   }
    //   if (type === 'restrictions') {
    //     for (i = 0; i < data.length; i++) {
    //       let obj = {
    //         label: data[i].rst_name,
    //         value: data[i].rst_id
    //       }
    //       res.push(obj)
    //     }
    //   }
    //   if (type === 'currency') {
    //     for (i = 0; i < data.length; i++) {
    //       let obj = {
    //         label: data[i].cur_name,
    //         value: data[i].cur_id
    //       }
    //       res.push(obj)
    //     }
    //   }
    //   if (type === 'measurementUnit') {
    //     for (i = 0; i < data.length; i++) {
    //       let obj = {
    //         label: data[i].mun_unit,
    //         value: data[i].mun_id
    //       }
    //       res.push(obj)
    //     }
    //   }
    //    if (type === 'categories') {
    //     for (i = 0; i < data.length; i++) {
    //       let obj = {
    //         label: data[i].cat_name,
    //         value: data[i].cat_id
    //       }
    //       res.push(obj)
    //     }
    //   }
    //   if (type === 'subcategories') {
    //     for (i = 0; i < data.length; i++) {
    //       let obj = {
    //         label: data[i].cat_name,
    //         value: data[i].cat_id
    //       }
    //       res.push(obj)
    //     }
    //   }
    //   if (type === 'region') {
    //     for (i = 0; i < data.length; i++) {
    //       let obj = {
    //         label: data[i].reg_name,
    //         value: data[i].reg_id
    //       }
    //       res.push(obj)
    //     }
    //   }
    //   return res
    // },
    checkOtherRules (infoDataAdd) {
      for (let i in infoDataAdd) {
        if (
          (i === 'pro_return_shipping_requirements' ||
            i === 'pro_no_reject_condition' ||
            i === 'pro_postal_info' ||
            i === 'pro_return_shipping_cost' ||
            i === 'pro_court_avoidance' ||
            i === 'pro_rules' ||
            i === 'pro_reject_rules') &&
          infoDataAdd[i] != null &&
          infoDataAdd[i] !== ''
        ) {
          console.log(i)
          this.otherRights2Condition = true
        }
      }
    }
  },
  computed: {
    getMaxPrice () {
      if (this.prices.length > 0) {
        return this.parseNumber(this.prices[this.prices.length - 1].price) - 1
      } else {
        return this.parseNumber(this.basePrice)
      }
    },
    getFilterValue () {
      return name => {
        let obj = null
        if (this.selectedFilters.hasOwnProperty(name)) {
          obj = this.selectedFilters[name]
        }
        return obj
      }
    },
    getMainImage () {
      return baseURL + '/image/' + this.productInfoEdited.img_id
    },
    getImage () {
      return img => {
        return baseURL + img
      }
    },
    getInputs () {
      let res = []
      for (var i = 0; i < this.inputs.length; i++) {
        if (
          this.inputs[i].condition &&
          this.inputs[i].condition === 'otherRights2Condition' &&
          !this.otherRights2Condition
        ) {
        } else {
          res.push(this.inputs[i])
        }
      }
      return res
    }
    // getImageFile () {
    //   return file => {
    //     let arr = [file]
    //     let res = this.createPreviews(arr)
    //     return res
    //   }
    // }
  },
  watch: {
    'productInfoEdited.pro_quality': {
      handler (newVal) {
        if (newVal) {
          this.numProofQuality =
            this.newProQuality.length +
            (this.productInfoEdited.pro_quality
              ? this.productInfoEdited.pro_quality.length
              : 0)
        }
      }
    },
    'productInfoEdited.pro_image': {
      handler (newVal) {
        if (newVal) {
          this.numImages =
            this.newImages.length +
            (this.productInfoEdited.pro_image
              ? this.productInfoEdited.pro_image.length
              : 0)
        }
      }
    },
    'productInfoEdited.cat_id': {
      handler (newVal) {
        this.productInfoEdited.filters = '[]'
        this.selectedFilters = {}
        this.handleFilters(newVal)
      }
    },
    newProQuality: {
      handler (newVal) {
        this.numProofQuality =
          newVal.length +
          (this.productInfoEdited.pro_quality
            ? this.productInfoEdited.pro_quality.length
            : 0)
      }
    },
    newImages: {
      handler (newVal) {
        this.numImages =
          newVal.length +
          (this.productInfoEdited.pro_image
            ? this.productInfoEdited.pro_image.length
            : 0)
      }
    },
    date: {
      handler () {
        this.productInfoEdited.pro_expiry = this.date
      }
    },
    '$route.params.lang': {
      handler: function () {
        this.getRegions()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-ad-wrapper-background {
  background: #f2f2f2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;
  @import '@/assets/scss/btnStyles.scss';
  .btn {
    // max-width: 100px;
  }

  input {
    height: 40px;
    border: 1px solid #e8e8e8;
    padding-left: 5px;
  }

  .header {
    text-align: left;
    margin-top: 20px;
    margin-bottom: 30px;
    font-size: 18px;
    border-bottom: 1px solid $main-color;
  }

  .edit-ad-wrapper {
    display: flex;
    height: 100%;
    max-width: 1600px;
    width: calc(100% - 40px);
    margin: 0 auto;
    background: white;
    padding: 40px 40px;
    box-sizing: border-box;
    flex-direction: column;

    h1 {
      font-weight: 800;
      font-size: 24px;
      line-height: 39px;
      letter-spacing: 0.01em;
      margin: 0;
      margin-bottom: 30px;
      text-transform: uppercase;
    }
    .info {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      // max-width: 500px;
      width: 100%;
      margin: 0 auto;
      margin-bottom: 20px;
      flex-wrap: wrap;
      text-align: left;

      .info-key {
        font-weight: normal;
        font-size: 13px;
        line-height: 21px;
        color: #787878;
        margin-right: 15px;
        white-space: break-spaces;
        width: 300px;
        flex-wrap: wrap;
      }
      .info-value {
        font-weight: 800;
        font-size: 13px;
        line-height: 21px;
        letter-spacing: 0.02em;
        color: $text-color;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        flex-grow: 1;

        .img-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .img-wrapper:hover {
          cursor: pointer;
          .remove {
            opacity: 0.7;
          }
          img {
            opacity: 0.3;
          }
        }
        .remove {
          position: absolute;
          margin: 0 auto;
          opacity: 0;
          transition-duration: 0.3s;
        }
        img {
          transition-duration: 0.3s;
          height: auto;
          width: auto;
          max-height: 100px;
          max-width: 100px;
          border-radius: 5px;
          margin-right: 5px;
          margin-bottom: 5px;
        }
        input {
          width: 100%;
        }
        textarea {
          width: 100%;
        }
        input[type='checkbox'],
        input[type='date'] {
          width: auto;
        }
        .filter-wrapper {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
